import { gql } from "@apollo/client"
import { TRIP_ORDERS_FRAG } from "./dispatch.fragments.gql"

// export const ALL_CONFIRMED_ORDERS = gql`
//   # query allConfirmedOrders(){

//   # }
//   query allConfirmedOrders(){
//     allOrders(filter:{

//     }) {

//     }
//   }
// `;

export const DISPATCHES_FOR_DATE = gql`
  query DispatchesForDate(
    $date: Date!
    $query: String
    $first: Int
    $skip: Int
    $distributionCentreId: ID
  ) {
    tripsForDate(
      date: $date
      query: $query
      first: $first
      skip: $skip
      distributionCentreId: $distributionCentreId
    ) {
      id
      status
      totalCrateCount
      destinationDepot {
        id
        name
      }
      sourceDepot {
        id
        name
      }
      vehicle {
        id
        registrationNumber
        vehicleType {
          id
          name
          category
        }
        driver {
          id
          fullName
          number
        }
      }
      aggregator {
        id
        fullName
        number
      }
      estimatedStartTime

      bookings {
        id
        schedule {
          id
        }
        requiredQuantity
        orderItem {
          id
          sellableItem {
            id
            name
          }
          quantity
          rate
        }
        order {
          id
          totalAmount
          orderStatus
          shippingAddress {
            id
            village
          }
        }
      }
    }
  }
`
export const DISPATCH_DEPOTS = gql`
  query allDispatchDepotsSelector {
    allDepots {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
  }
`
export const SUBORDER_ORDER_DETAIL = gql`
  query SuborderOrderDetail($orderId: ID!) {
    orderDetail(id: $orderId) {
      id
      subOrders {
        id
        date
        trackingCode
        totalWeight
        orderCategory
        shippingAddress {
          id
          address
          latitude
          longitude
          village
          taluka
        }
        user {
          id
          fullName
        }
        crateCount
        orderStatus
        orderItems {
          id
          quantity
          rate
          bookedQuantity
          order {
            id
          }
          sellableItem {
            id
            name
          }
        }
      }
    }
  }
`
export const CONFIRMED_ORDER_LIST = gql`
  query ConfirmedOrderList(
    $query: String
    $first: Int
    $skip: Int
    $filter: OrderFilterInput
    $sellableItemIds: [ID]
  ) {
    allOrders(query: $query, first: $first, skip: $skip, filter: $filter) {
      id
      date
      trackingCode
      totalWeight
      orderCategory
      shippingAddress {
        id
        address
        latitude
        longitude
        village
        taluka
      }
      user {
        id
        fullName
      }
      crateCount
      subOrders {
        id
      }
      orderStatus
      orderItems(sellableItemIds: $sellableItemIds) {
        id
        quantity
        rate
        bookedQuantity
        order {
          id
        }
        sellableItem {
          id
          name
        }
      }
    }
  }
`

export const TRIP_ORDERS = gql`
  query TripOrders($id: Int) {
    tripDetails(tripId: $id) {
      ...TripOrdersFrag
    }
  }
  ${TRIP_ORDERS_FRAG}
`

export const DISPATCH_VEHICLES = gql`
  query allDispatchVehicles {
    allVehicles {
      id
      driver {
        id
        fullName
        number
      }
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
    }
  }
`

/**
 * This query gets all the bookings in which an orderItem is split
 */

export const ORDER_ITEM_BOOKINGS = gql`
  query OrderItemBookings($orderItemId: ID!) {
    bookingsByOrderItem(orderItemId: $orderItemId) {
      id
      orderItem {
        id
        sellableItem {
          id
          name
        }
      }
      requiredQuantity
      trip {
        id
        status
        date
        vehicle {
          id
          registrationNumber
        }
        aggregator {
          id
          fullName
        }
      }
    }
  }
`
